import { useEffect, useState } from "react";

const STORAGE_KEY = "scheduling.showThumbnails";

function readInitial(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function useShowThumbnails(): [boolean, (next: boolean) => void] {
  const [show, setShow] = useState<boolean>(readInitial);

  useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) {
        setShow(e.newValue === "true");
      }
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  const update = (next: boolean) => {
    setShow(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next ? "true" : "false");
    } catch {
      // ignore — non-critical
    }
  };

  return [show, update];
}
